import React, { useCallback } from 'react';
import {
  Box,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ZerpaTable, { ColumnObject } from '../layout/table/ZerpaTable';
import { convertToQid } from '../../utilities/stringHelper';
import { DigitalGroundTruthGroup, Enrollment, Institute } from '../../redux/types';

type EnrollmentsWithInstitute = Enrollment & { institute: Institute };

type Props = {
  enrollments: EnrollmentsWithInstitute[];
  goToReview: (trialId: number, enrollmentId: number) => void;
  digitalGroundTruthGroupById?: Record<number, DigitalGroundTruthGroup>;
};

type MappedEnrollment = Enrollment & {
  qId: string;
  groundTruthIndex?: number;
};

const getZerpaColumns = (anonomyize: boolean, showGTGroup: boolean) : ColumnObject[] => {
  const zerpaColumn: ColumnObject[] = anonomyize ? [
    {
      keyName: 'sampleset',
      text: <FormattedMessage id="review.anonymizeHeader" />,
      sortable: true,
    },
  ] : [
    {
      keyName: 'qId',
      text: 'Q-ID',
      sortable: true,
    },
  ];
  zerpaColumn.push({
    keyName: 'createdAt',
    text: <FormattedMessage id="trialdetails.enrollDate" />,
    sortable: true,
    isDate: true,
  });

  if (showGTGroup) {
    zerpaColumn.push({
      keyName: 'groundTruthIndex',
      text: <FormattedMessage id="groundtruthNo" />,
      sortable: true,
    });
  }
  return zerpaColumn;
};

const ReviewSubmissionsV2: React.FC<Props> = ({
  enrollments,
  goToReview,
  digitalGroundTruthGroupById,
}: Props) => {
  const anonymize = !!enrollments.find((e) => e.sampleset !== null);
  const showGTGroup = !!digitalGroundTruthGroupById;
  const mappedEnrollmentList = enrollments
    .map((e): MappedEnrollment => {
      const list = {
        ...e,
        qId: convertToQid(e.attendeeId, e.institute.country),
      } as MappedEnrollment;
      if (showGTGroup && e.digitalGroundTruthGroupId) {
        list.groundTruthIndex = digitalGroundTruthGroupById[e.digitalGroundTruthGroupId]?.index;
      }
      return list;
    });

  const rowClickHandler = useCallback((rowData: MappedEnrollment) => {
    goToReview(rowData.trialId, rowData.id);
  }, [goToReview]);

  return (
    <Box>
      <ZerpaTable<MappedEnrollment>
        columns={getZerpaColumns(anonymize, showGTGroup)}
        keyIdentifier="id"
        tableRows={mappedEnrollmentList}
        rowClick={rowClickHandler}
        dense
      />
    </Box>
  );
};

export default ReviewSubmissionsV2;
